'use client';

import { Analytics as VercelAnalytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/next';

export function Analytics() {
  // Only disable in development if explicitly set to false
  const isDevelopment = process.env.NODE_ENV === 'development';
  const analyticsDisabled = process.env.NEXT_PUBLIC_ENABLE_ANALYTICS === 'false';
  
  if (isDevelopment && analyticsDisabled) {
    return null;
  }

  return (
    <>
      <VercelAnalytics />
      <SpeedInsights />
    </>
  );
}